import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  faExclamationTriangle,
  faCheckCircle,
  faInfoCircle,
  faBell,
  faPencilAlt as falPencil,
  faSave as falSave,
} from "@fortawesome/free-solid-svg-icons";
import { WatchlistService } from "../watchlist.service";
import { AppService } from "../../app.service";
import { AlertsDataService } from "src/app/shared/alerts/alerts-data.service";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import {
  AddWatchlistData,
  UpdateWatchlistData,
  SetSelectedWatchlist,
} from "src/app/store/actions/global.actions";
import { WatchlistPageService } from "src/app/watchlist-page/watchlist-page.service";
import { LeftPanel } from "src/app/store/models/global.model";
import { Dictionary } from "src/app/store/models/common_types";
import { Router } from "@angular/router";
import { WatchlistSearchAddComponent } from "../watchlist-search-add/watchlist-search-add.component";

@Component({
  selector: "app-watchlist-modal",
  templateUrl: "./watchlist-modal.component.html",
  styleUrls: ["./watchlist-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: "watchlist-modal" },
})
export class WatchlistModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean;
  @Input() receivedWatchlist: boolean;
  @Input() modalTitle: string;
  @Input() selectedWatchlistName: string;
  @Input() selectedWatchlistId: number;
  @Input() existingTickers: Array<any>;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() updatedWatchlistData = new EventEmitter<any>();
  isDirty = false;
  isVisibleConfirmModal = false;
  currentIndex = 1;
  faExclamationTriangle = faExclamationTriangle;
  faBell = faBell;
  falPencil = falPencil;
  fasSave = falSave;
  inEditMode = false;
  step2Context = "searchAndAdd"; //other value can be searchAndAdd
  saveTrigger = 0;
  existingWalichists: Array<string> = [];
  watchlistName = "";
  watchistError = "";
  watchlistData: Array<any> = [];
  invalidCount = 0;
  warningType = "";
  tickerList: Array<string> = [];
  faCheckCircle = faCheckCircle;
  faInfoCircle = faInfoCircle;
  enableAlerts = true;
  enableAlertsBtn = true;
  watchlistId = "";
  disableSaveWatchlistBtn = true;
  isLoadingSaveWatchlist = false;
  isLoadingSaveAlerts = false;
  storeDataKey = "watchlist";
  disableIgnoreSaveBtn = false;
  watchlistIdNameMapping: Dictionary<any>;
  alertsData: any;
  redirectOnClose = false;
  @ViewChild(WatchlistSearchAddComponent)
  watchlistSearchAddComponent: WatchlistSearchAddComponent;

  constructor(
    private dataService: WatchlistService,
    private alertsDataService: AlertsDataService,
    private appService: AppService,
    private store: Store<AppState>,
    private watcherService: WatchlistPageService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.clearData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.visible &&
      changes.visible.currentValue !== changes.visible.previousValue
    ) {
      this.redirectOnClose = false;
    }
    if (this.visible) {
      if (
        this.selectedWatchlistId &&
        this.selectedWatchlistName !== "" &&
        this.existingTickers.length > 0
      ) {
        //edit watchlist call
        this.watchlistName = this.selectedWatchlistName;
        this.currentIndex = 1;
        this.tickerList = [...this.existingTickers];
        if (this.receivedWatchlist) {
          setTimeout(() => {
            document.getElementById("input_name").click();
          }, 1000);
        }
      }
      if (this.existingWalichists.length === 0) {
        // adding here because onInit never calls if popover already opened before => so unable to get recently added watchlist names
        this.dataService.getWatchlists().subscribe(
          (response) => {
            this.existingWalichists = response.data.map((data) => {
              return data.w_name.trim().toLowerCase();
            });
            if (this.watchlistName === "")
              this.watchlistName = this.getDefaultWatchlistName();
          },
          (error) => {
            throw error;
          },
        );
      }
    }

    this.store
      .select(stateGetter("leftPanel", "data"))
      .subscribe((data: LeftPanel) => {
        if ("watchlist" in data) {
          const allWatchlistData: Array<any> =
            data["watchlist"]["data"][1]["values"];
          this.watchlistIdNameMapping = allWatchlistData.reduce((kvp, wd) => {
            kvp[wd.label] = wd.watchlistId;
            return kvp;
          }, {});
        }
      });
  }

  getDefaultWatchlistName() {
    const defaultName = "Watchlist";
    let defaultNo = 1;
    let nameFound = false;
    while (!nameFound) {
      const newName = (defaultName + defaultNo).toLowerCase();
      if (!this.existingWalichists.includes(newName)) {
        nameFound = true;
        break;
      }
      defaultNo++;
    }
    return defaultName + defaultNo;
  }

  redirectIfNeeded() {
    // if user is on watchlist page, then take him to this watchlist
    if (
      this.redirectOnClose &&
      this.watchlistId &&
      window.location.pathname.split("/")[1] === "watchlist"
    ) {
      this.router.navigateByUrl(`/watchlist/${this.watchlistId}`);
    }
  }
  closeModal() {
    if (this.currentIndex === 1) {
      this.showConfirmModal("Close");
    } else {
      this.onClose.emit(true);
      this.updatedWatchlistData.emit(this.tickerList);
      this.clearData();
    }
    this.redirectIfNeeded();
  }

  moveToNextStep(extras?) {
    if (this.selectedWatchlistName !== undefined && this.watchlistName === "") {
      this.watchlistName = this.selectedWatchlistName;
    }
    if (this.currentIndex < 2) {
      this.currentIndex++;
      if (this.currentIndex === 1) {
        this.step2Context = extras.step2Context;
        this.invalidCount = extras.invalidCount;
      }
    }
  }

  handleConfirmModalCancel() {
    this.isVisibleConfirmModal = false;
  }

  showConfirmModal(title?: string) {
    if (this.isDirty) {
      this.warningType = title;
      this.isVisibleConfirmModal = true;
    } else {
      this.warningType = "Close";
      this.onClickWarningSubmit();
    }
  }

  onClickWarningSubmit() {
    this.isVisibleConfirmModal = false;
    this.watchlistName = "";
    this.watchistError = "";
    if (this.warningType === "Restart") {
      this.currentIndex = 1;
    } else {
      this.onClose.emit(true);
      this.clearData();
    }
  }

  onClickSaveWatchlist(event) {
    if (!event) {
      event = "savewatchlist";
    }
    this.saveTrigger++;
    setTimeout(this.saveWatchlist.bind(this, event), 50);
  }

  saveWatchlist(event) {
    this.onBlurWatchlistName();
    if (
      this.selectedWatchlistId !== undefined &&
      this.watchistError === "" &&
      !this.receivedWatchlist
    ) {
      this.updateWatchlistData();
    } else if (this.watchistError === "" && this.tickerList.length > 0) {
      const jsonData = {
        watchername: this.watchlistName,
        tickerlist: this.tickerList,
      };
      this.isLoadingSaveWatchlist = true;
      this.dataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          this.watchlistId = response.watchlistid.toString();
          this.redirectOnClose = true;
          this.appService.logUserAction(
            event,
            "",
            "",
            "Watchlist_Page",
            {
              watchlist_id: response.watchlistid,
              beginning_state_referrer: "Watchlist_Page",
            },
            "",
            "Watchlist_Save",
          );
          this.isLoadingSaveWatchlist = false;
          this.moveToNextStep();
          this.addWatchlistStore();
        },
        (error) => {
          this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  updateWatchlistData() {
    const updatedWatchlistObj = {
      watchername: this.watchlistName,
      watcherid: this.selectedWatchlistId,
      tickerlist: this.tickerList,
    };
    this.isLoadingSaveWatchlist = true;
    this.watcherService.updateWatchlist(updatedWatchlistObj).subscribe(
      (success: any) => {
        if (success) {
          this.isLoadingSaveWatchlist = false;
          this.updateWatchlistStore();
          this.onClickWarningSubmit();
        }
      },
      (err) => {
        this.isLoadingSaveWatchlist = false;
        console.error(err);
      },
    );
  }

  updateWatchlistStore() {
    const payload = {
      key: "watchlist",
      watchlistId: this.selectedWatchlistId,
      label: this.watchlistName,
    };
    this.store.dispatch(new UpdateWatchlistData(payload));

    this.store.dispatch(
      new SetSelectedWatchlist({
        label: this.watchlistName,
        watchlistId: this.selectedWatchlistId,
      }),
    );
  }

  addWatchlistStore() {
    const payload = {
      respData: {
        watchlistId: Number(this.watchlistId),
        label: this.watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  getUpdatedWatchListData(dataObj) {
    const watchListData = dataObj.data;
    const title = dataObj.context;
    this.step2Context = title;
    this.invalidCount = dataObj.invalidCount;
    if (title === "validation") {
      this.tickerList = dataObj.data
        .filter((x) => !x.hasError)
        .map(function (data) {
          return data.ticker;
        });
    } else {
      this.tickerList = watchListData;
    }
    this.disableIgnoreSaveBtn = this.invalidCount === dataObj.data.length;
    this.disableSaveWatchlistBtn = this.tickerList.length === 0;
    this.disableSaveWatchlistBtn = this.watchistError ? true : false;
    this.isDirty = true;
  }

  onBlurWatchlistName() {
    if (this.watchlistName.trim() === "") {
      this.watchistError = "Watchlist Name cannot be blank.";
    } else if (
      this.existingWalichists.indexOf(this.watchlistName.trim().toLowerCase()) >
      -1
    ) {
      //default state for both company and watchlist page
      this.watchistError = "Watchlist with the same name already exists";
      // specific for watchlistpage workflow wherein selectedWatchlistId exist and watchlistId does not
      if (
        !(
          this.watchlistId === "" &&
          this.selectedWatchlistId !== undefined &&
          this.watchlistIdNameMapping[this.watchlistName.trim()] ===
            this.selectedWatchlistId
        )
      ) {
        this.watchistError = "Watchlist with the same name already exists";
      } else {
        this.watchistError = "";
      }
    } else {
      this.watchistError = "";
    }
  }

  toggleEditMode = (watchlistRename: HTMLInputElement) => {
    this.inEditMode = !this.inEditMode;
    this.inEditMode ? watchlistRename.focus() : watchlistRename.blur();

    const validated = this.watchistError === "";

    if (
      !this.inEditMode &&
      validated &&
      this.selectedWatchlistName !== "" &&
      this.selectedWatchlistName !== this.watchlistName
    ) {
      this.disableSaveWatchlistBtn = this.tickerList.length === 0;
      this.isDirty = true;
    }
  };

  setEditMode = (watchlistRename: HTMLInputElement) => {
    this.inEditMode = true;
    watchlistRename.focus();
  };
  clearData() {
    this.currentIndex = 1;
    this.invalidCount = 0;
    this.tickerList = [];
    this.disableSaveWatchlistBtn = true;
    if (this.watchlistName !== undefined) {
      this.watchlistName = "";
    }
    this.isDirty = false;
    this.inEditMode = false;
  }

  getUpdatedAlertsData(alertsData) {
    this.alertsData = alertsData;
    this.enableAlertsBtn = this.isEnableAlertsBtn();
  }

  onClickSaveAlerts() {
    this.isLoadingSaveAlerts = true;
    this.alertsDataService.submitAlertsData(this.alertsData).subscribe(
      () => {
        this.appService.logUserAction(
          {},
          "",
          "",
          "WATCHLIST_ALERT_CREATE",
          { watchlist_id: this.watchlistId },
          "",
          "CREATE WATCHLIST ALERT",
        );
        this.redirectIfNeeded();
        this.watchlistName = "";
        this.watchlistId = "";
        this.isLoadingSaveAlerts = false;
        this.closeModal();
      },
      (error) => {
        this.isLoadingSaveAlerts = false;
        console.error(error);
      },
    );
  }

  isEnableAlertsBtn(): boolean {
    // if NONE of 'Alert Type' & 'Frequency' is selected then Save button should disabled
    if (
      this.alertsData.alert_email_frequency.length > 0 &&
      this.alertsData.alert_event_types.length > 0
    ) {
      return true;
    }
    return false;
  }

  navigateToWatchlistPage() {
    this.closeModal();
    this.router.navigateByUrl("/watchlist");
  }
  navigateToAlertsPage() {
    this.closeModal();
    this.router.navigateByUrl("/alert_settings");
  }

  onChangeAlertsSwitch(enableAlerts: boolean) {
    this.enableAlertsBtn =
      enableAlerts === false ? enableAlerts : this.isEnableAlertsBtn();
  }
}
